<template>
  <div>
    <vue-dropzone
      :options="dropzoneOptions"
      :include-styling="false"
      :use-custom-slot="true"
      id="dz"
      ref="dz"
      @vdropzone-file-added="fileAdded"
      @vdropzone-thumbnail="fileReady"
    >
      <slot />
    </vue-dropzone>

    <ImageInsertionDialog
      @insertImage="insertImage"
      @cancel="cancel"
      ref="imageInsertionDialog"
      :image-preview="fileToUpload"
      :dz="$refs.dz"
      :reflection-id="reflectionId"
    />
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import ImageInsertionDialog from './ImageInsertionDialog';

export default {
  name: 'UploadImageButton',
  components: {
    vueDropzone: vue2Dropzone,
    ImageInsertionDialog,
  },
  props: {
    reflectionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        maxFiles: 1,
        maxFilesize: 30,
        acceptedFiles: '.jpeg,.jpg,.gif,.png,.apng,.svg,.bmp',
        createImageThumbnails: true,
        autoProcessQueue: false,
      },
      fileToUpload: undefined,
    };
  },
  methods: {
    fileAdded() {
      this.$refs.imageInsertionDialog.dialog = true;
    },
    async fileReady(file) {
      await this.$nextTick();
      this.fileToUpload = file.dataURL;
    },
    insertImage(payload) {
      this.$emit('insertImage', payload);
    },
    cancel() {
      this.fileToUpload = undefined;
      this.$refs.dz.removeAllFiles();
    },
  },
  watch: {},
};
</script>

<style scoped>
::v-deep .dz-preview {
  display: none;
}
</style>
